enum PaymentVerificationStatus {
  PENDING = 'Pending',
  ACKNOWLEDGED = 'Acknowledged',
}

export default PaymentVerificationStatus;
